import { Component, OnInit } from '@angular/core';
import { LoanSettlementNegotiation } from '../../../../../../model/rbi-compliance/loan-settlement-negotiation.model';
import { LoanSettlementNegotiationService } from '../../../../../../service/rbi-compliance/loan-settlement-negotiation.service';
import { Keys, StorageService } from '../../../../../../service/storage.service';

@Component({
  selector: 'app-flex-loan-settlement',
  templateUrl: './flex-loan-settlement.component.html',
  styleUrls: ['./flex-loan-settlement.component.css']
})
export class FlexLoanSettlementComponent implements OnInit {
  loanSettlementNegotiation: LoanSettlementNegotiation;

  constructor(
    private readonly loanSettlementNegotiationService: LoanSettlementNegotiationService,
    private readonly storageService: StorageService
    ) { }

  ngOnInit(): void {
    this.getLoanSettlementNegotiationByLenderId();
  }

  public async getLoanSettlementNegotiationByLenderId() {
    this.loanSettlementNegotiation = null;
    this.loanSettlementNegotiationService.getLoanSettlementNegotiationByLenderId(this.getLenderId())
      .then((res) => {
        this.loanSettlementNegotiation = res;
      })
      .catch((err) => {
        console.log(err)
      })
  }

  private getLenderId(): string {
    return this.storageService.getItem(Keys.LENDER_ID);
  }
}
